export var MODULE_SOURCE = "@next-tsx/core";
export var CALL_API_LIST = ["callApi", "callHttp", "callTool", "callProvider", "copyText", "showDialog"];
export var HISTORY_METHODS = ["push", "replace", "reload", "pushQuery", "replaceQuery"];
//# sourceMappingURL=constants.js.map